import React, { Fragment, useEffect, useState } from "react";
import 'src/scss/mfs.css';
import {
  CCol,
  CModal,
  CFormGroup,
  CInputCheckbox,
  CLabel,
  CModalBody,
  CModalFooter,
  CTextarea,
} from "@coreui/react";
import ApiHelper from "src/utils/api/api_helper";
import ApoCntrHdwtRegPop from "./apoCntrHdwtRegPop";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert";
import { setReqTaskInfo, setClearReqTaskInfo, setClearReqTaskInfo2, reqTaskInfo } from "src/modules/insert";
import { InputWrap } from "src/reusable";

const HdwtGuideCpnt = (props) => {
  let { 
    data,
    hdwtInfo,
    stCd,
  } = props;

  return (
    <>
      { data.length > 0
        &&
        data.map((item) => {
          return(
            <CFormGroup row className="signBtn" key={item.HDWT_CAT_CD}>
              <CCol xs="8" className="text-left">
                <CFormGroup variant="checkbox" className="checkbox">
                  <CInputCheckbox
                    id={item.HDWT_CAT_CD}
                    name={item.HDWT_CAT_CD}
                    checked={
                      hdwtInfo.filter((item2) => item2.hdwtCatCd === item.HDWT_CAT_CD)[0].data ? true : false
                    }
                    readOnly
                  />
                  <CLabel variant="checkbox" className="form-check-label">
                    <b>{item.HDWT_TEXT}</b>
                  </CLabel>
                </CFormGroup>
              </CCol>
              <CCol xs="4">
                <button className="btn-footer" type="button"
                  onClick={() => props.onOpen(item.HDWT_CAT_CD, item.SIGN_YN)}
                  disabled={
                    stCd === "10" ||
                    stCd === "99"
                      ? false
                      : true
                  }
                >
                  {item.SIGN_YN == 'Y' ? '서명하기' : '따라쓰기'}
                </button>
              </CCol>
            </CFormGroup>
          )
        })
      }
    </>
  )
}

const ApoCntrFormPop = (props) => {
  const dispatch = useDispatch();
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const state = useSelector((state) => state);
  const { itmCd, mCheck } = props;
  const [files, setFiles] = useState([]);
  const [hdwtData, setHdwtData] = useState({});
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
    hdwtCatCd: 0,
    signYn: false
  });

  useEffect(async () => {
    let params = {};

    params.itmCd = itmCd;
    
    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItmFiles",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        params.fileSeqNoList = result.map((item) => item.FILE_SEQ_NO);

        setFiles(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });

    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItmFilesHdwtInfo",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        setHdwtData(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });
  }, []);

  const handelConfirm = async() => {
    const checks = document.querySelectorAll('.form-check-input');

    for(let item of checks) {
      if(!item.checked) {
        return Swal({
          title: "정보제공동의서",
          text: "문서내 서명을 모두 작성해야합니다.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }
    return props.onClose(); 
  }

  function onOpen(code, signYn) {
    setHdwtRegPop({
      isOpen: true,
      hdwtCatCd: code,
      signYn: signYn
    })
  }

  return (
    <>
      <CModal
        className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
        show={true}
        size="lg"
        closeOnBackdrop={false}
        onClosed={() => {
          props.onClose();
        }}
      >
        <CModalBody className="apoModalBody">
          { files.length > 0
            &&
            files.map((item) => {
              return (
                <Fragment key={item.FILE_SEQ_NO}>
                  <CFormGroup row>
                    <img
                      src={`${appUrl}cust/request/getImages/apoCntrForm?${item.MNG_FILE_NM}`}
                      alt={itmCd}
                      width="100%"
                    />
                  </CFormGroup>
                  { 
                    Object.keys(hdwtData).length !== 0
                    &&
                    hdwtData[item.FILE_SEQ_NO].length > 0
                    &&
                    <HdwtGuideCpnt 
                      data={hdwtData[item.FILE_SEQ_NO]}
                      hdwtInfo={state.apoCntrForm.apoCntrHdwtInfo}
                      stCd={state.insert.reqTaskInfo.stCd}
                      onOpen={onOpen}
                    >
                    </HdwtGuideCpnt>
                  }
                </Fragment>
              )
            })
          }
        </CModalBody>
        <CModalFooter>
          <div className="layout-footer">
            <button className="btn-footer" type="button" 
              onClick={
                state.insert.reqTaskInfo.stCd === "10" ||
                state.insert.reqTaskInfo.stCd === "99"
                ? handelConfirm
                : () => props.onClose()
              }>
                확인
            </button>
          </div>
        </CModalFooter>
      </CModal>
      {hdwtRegPop.isOpen && (
        <ApoCntrHdwtRegPop
          modal={true}
          hdwtCatCd={hdwtRegPop.hdwtCatCd}
          signYn={hdwtRegPop.signYn}
          display={hdwtRegPop.isOpen ? "display" : ""}
          onClose={() => setHdwtRegPop({ isOpen: false })}
        ></ApoCntrHdwtRegPop>
      )}
    </>
  );
};

export default ApoCntrFormPop;
